// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tetv-grid-wrapper {
  --tetv-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', sans-serif;
  --tetv-font-size: 1rem;
  --tetv-secondary-font-size: 0.875rem;
  --tetv-small-font-size: 0.8rem;
  --tetv-accent: #3f8fa3;
  --tetv-accent-dark: #256274;
  --tetv-ink: #1f2937;
  --tetv-muted: #667085;
  --tetv-line: #d9e1ea;
  --tetv-soft: #f6f9fb;
  --ag-font-family: var(--tetv-font-family);
  --ag-font-size: var(--tetv-font-size);
  --ag-foreground-color: var(--tetv-ink);
  --ag-border-color: var(--tetv-line);
  --ag-row-border-color: #94a3b8;
  --ag-header-column-resize-handle-color: #9fb3c6;
  --ag-selected-row-background-color: #e8f3f6;
  font-family: var(--tetv-font-family);
  font-size: var(--tetv-font-size);
  color: var(--tetv-ink);
  background: #fff;
  border: 1px solid var(--tetv-line);
  border-radius: 8px;
  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.08);
  box-sizing: border-box;
  margin-top: 8px;
  margin-left: 12px;
  padding: 0 0 12px;
}

.tetv-view-switchbar {
  display: flex;
  justify-content: center;
  padding: 6px 0 10px;
}
.tetv-view-toggle {
  background: #f2f6f8;
  border: 1px solid #d7e1e8;
  border-radius: 8px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
  padding: 3px;
}
.tetv-view-toggle .btn {
  align-items: center;
  border: 0;
  border-radius: 6px !important;
  display: inline-flex;
  gap: 6px;
  font-weight: 600;
  line-height: 1.2;
  padding: 0.35rem 0.65rem;
}
.tetv-view-toggle .btn-outline-secondary {
  color: #506172;
}
.tetv-view-toggle .btn-outline-secondary:hover,
.tetv-view-toggle .btn-outline-secondary:not(:disabled):not(.disabled).active {
  background: #fff;
  box-shadow: 0 2px 8px rgba(31, 41, 55, 0.12);
  color: #256274;
}

/* Sticky AgGrid header + a separate sticky horizontal scrollbar at the top.
   With domLayout="autoHeight" the grid has no internal vertical scrolling — the
   page is the only scroller. We pin .ag-header so column headers stay visible
   only once the user has actually scrolled past them; position:sticky kicks in
   exactly at top:0. The override on .ag-root-wrapper / .ag-root removes the
   overflow:hidden ancestors that would otherwise clip the sticky child. */
.tetv-grid-wrapper .ag-root-wrapper,
.tetv-grid-wrapper .ag-root,
.tetv-grid-wrapper .ag-body-viewport {
  overflow: visible;
}
.tetv-grid-wrapper .ag-root-wrapper {
  border-left: 0;
  border-radius: 0 0 8px 8px;
  border-right: 0;
}
/* Top scrollbar lives between the AgGrid header and the body. It is rendered via
   a React portal into a display:contents container placed after .ag-header inside
   .ag-root (see TetValidationGrid.jsx), so its sticky context is .ag-root while
   React keeps ownership of the node. The sticky \`top\` is set inline based on the
   measured header height so it pins right below the header when the page scrolls. */
.tetv-top-scroll {
  position: sticky;
  z-index: 3;
  overflow-x: auto;
  overflow-y: hidden;
  background: #f8fafc;
  border-top: 1px solid #d7e1e8;
  border-bottom: 1px solid #dfe7ef;
  height: 16px;
}
.tetv-top-scroll-inner {
  height: 1px;
}
.tetv-grid-wrapper .ag-header {
  position: sticky;
  top: 0;
  z-index: 4;
}
.tetv-banner-unresolved {
  background: #fff3cd;
  padding: 6px 10px;
  margin: 10px 12px 0;
  border: 1px solid #ffe69c;
  border-radius: 7px;
  font-size: var(--tetv-font-size);
}

.tetv-toolbar {
  background: #fbfcfd;
  border-bottom: 1px solid var(--tetv-line);
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  padding: 10px 12px;
  align-items: center;
}
.tetv-toolbar-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.tetv-toolbar-options {
  background: #fff;
  border: 1px solid #e1e8ef;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(31, 41, 55, 0.04);
  gap: 12px;
  padding: 6px 10px;
}
.tetv-toolbar-options .form-check {
  align-items: center;
  display: inline-flex;
  margin-bottom: 0;
  margin-right: 0;
}
.tetv-toolbar-options .form-check-input {
  margin-top: 0;
}
.tetv-toolbar-options .form-check-label {
  color: #344054;
  font-size: var(--tetv-secondary-font-size);
  font-weight: 600;
  padding-left: 4px;
}
.tetv-toolbar-select {
  flex: 1 1 280px;
  min-width: 240px;
  max-width: 480px;
}
.tetv-toolbar-label {
  font-size: var(--tetv-secondary-font-size);
  color: #344054;
  font-weight: 700;
  white-space: nowrap;
}
.tetv-quick-link {
  background: #fff;
  border: 1px solid #d7e1e8;
  color: var(--tetv-accent-dark);
  font-size: var(--tetv-secondary-font-size);
  font-weight: 700;
  line-height: 1.1;
  padding: 5px 8px;
  cursor: pointer;
  border-radius: 999px;
}
.tetv-quick-link:hover {
  background: #e8f3f6;
  border-color: #a9ccd6;
}
.tetv-select-shell {
  flex: 1 1 240px;
  min-width: 240px;
}

/* Each topic is rendered as a column group with two children: Validation
   (narrow, just buttons) and Sources (wide, source mini-rows).
   We draw a thick left border on the leftmost cell of each topic group to
   visually separate adjacent topic groups. */
.tetv-validation-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  padding: 4px 2px;
  height: 100%;
}
.tetv-validation-by {
  font-size: var(--tetv-small-font-size);
  color: #4a5260;
  line-height: 1.25;
  text-align: center;
  word-break: break-word;
}
.tetv-validation-by-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  align-items: stretch;
  width: 100%;
}
.tetv-validation-by-mark {
  display: inline-block;
  font-weight: 700;
  min-width: 1.1em;
  padding: 0 4px;
  border-radius: 8px;
  text-align: center;
  color: #fff;
}
.tetv-validation-by-pos { background: #1e7d3a; }
.tetv-validation-by-neg { background: #b03a2e; }
.tetv-source-icon {
  display: inline-block;
  min-width: 1.4em;
  padding: 0 6px;
  height: 1.4em;
  border-radius: 999px;
  background: var(--tetv-accent);
  color: #fff;
  font-weight: 600;
  font-size: 0.8em;
  line-height: 1.4em;
  text-align: center;
  margin: 0 2px;
  vertical-align: middle;
}
/* Species badge: same shape/size as source icons but a distinct olive hue so
   curators can tell at a glance which TET tags were submitted for a given
   species. Hover tooltip carries the full binomial. */
.tetv-species-icon {
  display: inline-block;
  min-width: 1.4em;
  padding: 0 6px;
  height: 1.4em;
  border-radius: 999px;
  background: #6b7c3a;
  color: #fff;
  font-weight: 700;
  font-style: italic;
  font-size: 0.8em;
  line-height: 1.4em;
  text-align: center;
  margin: 0 2px;
  vertical-align: middle;
}
.tetv-sources-cell,
.tetv-tag-cell,
.tetv-attr-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 6px;
  min-width: 0;
}
.tetv-tag-cell {
  align-items: center;
}
/* Evidence-assertion panels: one panel per source_evidence_assertion bucket.
   Sources column shows the assertion name as a panel title; the other
   per-source columns render a same-height spacer so mini-rows still align
   horizontally across columns inside a single AgGrid row. */
.tetv-evidence-panel {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
}
.tetv-evidence-panel-sep {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #d9e1ea;
}
.tetv-evidence-title {
  font-size: var(--tetv-small-font-size);
  font-weight: 700;
  color: var(--tetv-accent-dark);
  text-transform: lowercase;
  line-height: 1.3;
  padding: 0 0 2px;
  text-align: left;
  /* Resolved ontology names can exceed the fixed Sources column width; clip to a
     single line (keeping the one-line title-spacer height match that preserves
     cross-column mini-row alignment) and expose the full text via the tooltip. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tetv-evidence-title-spacer {
  font-size: var(--tetv-small-font-size);
  font-weight: 700;
  line-height: 1.3;
  padding: 0 0 2px;
  visibility: hidden;
  text-align: left;
}
.tetv-evidence-empty {
  color: var(--tetv-muted);
  font-size: var(--tetv-small-font-size);
}
.tetv-attr-value {
  font-size: inherit;
  color: #2a2f36;
  font-variant-numeric: tabular-nums;
}
.tetv-note-count {
  font-size: var(--tetv-small-font-size);
  margin-left: 2px;
}
/* Inner separators between sub-columns within a topic group, matching the
   sub-header borders. The leftmost cell of each topic group keeps a thicker
   left border to separate adjacent topic groups. */
.tetv-grid-wrapper .ag-cell {
  border-right: 1px solid #e5ebf1;
}
.tetv-grid-wrapper .ag-header-cell.tetv-topic-subheader,
.tetv-grid-wrapper .ag-header-group-cell.tetv-topic-group-header {
  border-right: 1px solid #d0dce7;
}
.tetv-topic-group-leftmost {
  border-left: 3px solid #a9ccd6 !important;
}
.tetv-grid-wrapper .ag-header,
.tetv-grid-wrapper .ag-header-row {
  background: #eef4f7;
}
.tetv-grid-wrapper .ag-header-cell,
.tetv-grid-wrapper .ag-header-group-cell {
  background: #eef4f7;
  color: var(--tetv-ink);
  font-weight: 700;
}
.tetv-grid-wrapper .ag-header-cell-label,
.tetv-grid-wrapper .ag-header-group-cell-label {
  align-items: center;
}
.ag-header-group-cell.tetv-topic-group-header {
  border-left: 3px solid #a9ccd6;
  background: linear-gradient(180deg, #e7f1f4, #dfeaf0);
  font-weight: 700;
  color: var(--tetv-accent-dark);
}
.ag-header-cell.tetv-topic-subheader {
  background: #f8fafc;
  font-size: var(--tetv-secondary-font-size);
  color: #475467;
  font-weight: 600;
}
/* Nested group inside a topic group: the "Data assessment by other sources"
   band that spans the source label, its Y/N/{N}E tag and the optional
   confidence / note columns. Toned between the topic-name band above it and
   the leaf sub-headers below so the three levels stay distinguishable. */
.ag-header-group-cell.tetv-topic-subgroup-header {
  background: #eef3f7;
  font-size: var(--tetv-secondary-font-size);
  font-weight: 700;
  color: #3d5566;
  border-right: 1px solid #d0dce7;
  border-bottom: 1px solid #dbe4ec;
}
/* The biocurator column has no nested group above it, so AgGrid renders an
   empty group cell in that row. Keep it blank rather than showing a stray
   band of the sub-group tone. */
.tetv-grid-wrapper .ag-header-group-cell-no-group {
  background: #f8fafc;
  border-right: 1px solid #d0dce7;
}
/* Alternating row tones for readability. Each paper is separated by a
   prominent slate-grey divider so curators clearly see where one paper ends
   and the next begins. */
.tetv-grid-wrapper .ag-row {
  background: #ffffff;
  border-bottom: 2px solid #94a3b8;
}
.tetv-grid-wrapper .ag-row-odd {
  background: #f8fafc;
}
.tetv-grid-wrapper .ag-row:hover {
  background: #edf8f7;
}
/* Reference rows that already carry a professional-biocurator topic-level
   TET on at least one topic — soft amber background so curators spot them
   immediately. Overrides the zebra striping. */
.tetv-grid-wrapper .ag-row.tetv-row-validated,
.tetv-grid-wrapper .ag-row.tetv-row-validated.ag-row-odd {
  background: #fff8ed;
}
.tetv-grid-wrapper .ag-row.tetv-row-validated:hover {
  background: #ffefd1;
}

/* Status text shown in the Validation cell when a professional-biocurator
   topic-level tag exists for that (ref, topic). Replaces the ✓/✗ buttons. */
.tetv-validation-status {
  font-size: 1rem;
  font-weight: 700;
  padding: 7px 14px;
  /* Y and N are single characters — keep both pills the same size so a column
     of assessments reads as one consistent shape. */
  min-width: 2.75rem;
  border-radius: 999px;
  text-align: center;
  white-space: normal;
  line-height: 1.25;
  border: 1px solid transparent;
  box-shadow: 0 1px 2px rgba(31, 41, 55, 0.08);
}
.tetv-validated-pos {
  background: #dff4e7;
  color: #17613a;
  border-color: #b9e4c8;
}
.tetv-validated-neg {
  background: #fde3e8;
  color: #8f2435;
  border-color: #f7bdc8;
}
.tetv-validated-conflict {
  background: #fff0c9;
  color: #855600;
  border-color: #f3d27e;
}
.tetv-source-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.tetv-source-group-sep {
  border-top: 1px dotted #ddd;
  padding-top: 2px;
}
.tetv-mini-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--tetv-font-size);
  line-height: 1.3;
  flex-wrap: nowrap;
  /* Single-line mini-rows so the columns can be auto-sized to fit content
     without vertical stacking. The grid horizontal-scrolls when wider than
     the viewport. */
}
.tetv-tag-row {
  justify-content: center;
  width: 100%;
}
.tetv-source-label {
  color: #475467;
  white-space: nowrap;
  font-weight: 500;
}
.tetv-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  padding: 0 7px;
  border-radius: 999px;
  color: #fff;
  font-size: var(--tetv-small-font-size);
  font-weight: 800;
  text-align: center;
  line-height: 20px;
  height: 20px;
  white-space: nowrap;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.13);
}
.tetv-pill-y { background: #268d52; }
.tetv-pill-n { background: #c63f4f; }
/* Entity count badge — distinct violet so curators can spot it apart from
   the Y/N pills used for topic-only tags. */
.tetv-pill-entity { background: #6679c8; }
.tetv-pill-entity-neg { background: #495aa2; }
.tetv-pill-clickable {
  border: 0;
  cursor: pointer;
  font: inherit;
}
.tetv-pill-clickable:hover {
  filter: brightness(1.08);
  transform: translateY(-1px);
}
.tetv-dot-y, .tetv-dot-n {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}
.tetv-dot-y { background: #268d52; }
.tetv-dot-n { background: #c63f4f; }
.tetv-inline-note {
  color: #333;
  font-style: italic;
  /* Full note text — wraps freely, no truncation. */
  white-space: pre-wrap;
  word-break: break-word;
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
}
.tetv-inline-note-line {
  display: block;
}
.tetv-inline-note-entity {
  font-weight: 600;
  font-style: normal;
  color: #2a2f36;
}
.tetv-note-btn {
  background: none;
  border: 0;
  color: #667085;
  cursor: pointer;
  padding: 0 2px;
}
.tetv-note-btn:hover { color: var(--tetv-accent-dark); }
.tetv-badge {
  font-size: var(--tetv-small-font-size);
  padding: 2px 6px;
  border-radius: 999px;
  background: #edf1fb;
  color: #3c4f8f;
  font-weight: 700;
}
.tetv-badge-score {
  background: #e8f4ed;
  color: #276749;
}

/* Validation strip: horizontal pair of icon-only buttons. */
.tetv-strip {
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 0;
  border: 0;
  flex: 0 0 auto;
}
.tetv-strip-btn {
  background: #fff;
  border: 1px solid #d7e1e8;
  border-radius: 999px;
  padding: 4px 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  width: auto;
  height: 36px;
  font-size: 24px;
  line-height: 1;
  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;
}
.tetv-strip-btn:disabled { opacity: 0.4; cursor: default; }
.tetv-strip-pos { color: #268d52; }
.tetv-strip-neg { color: #c63f4f; }
.tetv-strip-btn:hover:not(:disabled) { transform: translateY(-1px); }
.tetv-strip-pos:hover:not(:disabled) {
  background: #e7f5ec;
  border-color: #9ad0ae;
}
.tetv-strip-neg:hover:not(:disabled) {
  background: #fdecef;
  border-color: #e8a5af;
}
.tetv-strip-active {
  background: #f2f6f8;
  border-color: #8ba6b6;
}

.tetv-title-cell,
.tetv-ids-cell {
  display: flex;
  flex-direction: column;
  padding: 4px;
  line-height: 1.3;
}
.tetv-title-cell {
  white-space: normal;
}
.tetv-ids-cell {
  white-space: nowrap;
}
.tetv-ref-title {
  color: var(--tetv-ink);
  font-weight: 600;
  word-break: break-word;
}
.tetv-ref-journal {
  font-size: var(--tetv-secondary-font-size);
  color: #667085;
  font-style: italic;
}
.tetv-ref-authors {
  font-size: var(--tetv-secondary-font-size);
  color: #667085;
}
.tetv-ref-curie,
.tetv-ref-pmid,
.tetv-ref-xref {
  font-size: var(--tetv-secondary-font-size);
  color: #555;
  font-variant-numeric: tabular-nums;
  overflow-wrap: normal;
  word-break: normal;
  white-space: nowrap;
}
.tetv-ref-curie { color: var(--tetv-accent-dark); font-weight: 700; }

/* Per-reference action strip rendered at the bottom of IdsCell. Mirrors
   the list-view's TET-editor + main-PDF buttons but in a compact pill
   layout so it doesn't dominate the pinned column. */
.tetv-ref-actions {
  display: flex;
  gap: 6px;
  margin-top: 4px;
}
.tetv-ref-action {
  align-items: center;
  background: #fff;
  border: 1px solid #d7e1e8;
  border-radius: 999px;
  color: var(--tetv-accent-dark);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--tetv-small-font-size);
  font-weight: 700;
  gap: 4px;
  line-height: 1.1;
  padding: 3px 8px;
  text-decoration: none;
}
.tetv-ref-action:hover {
  background: #e8f3f6;
  border-color: #a9ccd6;
  color: var(--tetv-accent-dark);
  text-decoration: none;
}
.tetv-ref-action-pdf {
  color: #8c2c2c;
  border-color: #e6c2c2;
}
.tetv-ref-action-pdf:hover {
  background: #fbecec;
  border-color: #d99a9a;
  color: #6e2222;
}
.tetv-ref-action-label {
  font-size: var(--tetv-small-font-size);
}

/* Leading pinned checkbox column for bulk selection. Compact + centered. */
.tetv-grid-wrapper .ag-cell.tetv-select-cell,
.tetv-grid-wrapper .ag-header-cell.tetv-select-header {
  padding-left: 8px;
  padding-right: 4px;
}
.tetv-grid-wrapper .ag-cell.tetv-select-cell .ag-selection-checkbox,
.tetv-grid-wrapper .ag-header-cell.tetv-select-header .ag-header-select-all {
  margin: 0;
}

/* Bulk-action bar — visible only when at least one row is checkbox-selected.
   Sits between the regular toolbar and the grid, with a coloured stripe so
   the curator notices they're operating on a multi-row batch. */
.tetv-bulk-bar {
  align-items: center;
  background: #fff8ed;
  border-bottom: 1px solid var(--tetv-line);
  border-top: 1px solid var(--tetv-line);
  border-left: 4px solid #f3b765;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  padding: 10px 12px;
}
.tetv-bulk-count {
  color: #6b4a16;
  font-weight: 600;
}
.tetv-bulk-count strong {
  color: #855600;
  font-size: 1.05em;
}
.tetv-bulk-msg {
  color: #475467;
}
.tetv-bulk-topic {
  align-items: center;
  display: inline-flex;
}
.tetv-bulk-label {
  color: #344054;
  font-size: var(--tetv-secondary-font-size);
  font-weight: 700;
}
.tetv-bulk-actions {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  margin-left: auto;
}
.tetv-bulk-clear {
  color: #6b4a16;
  text-decoration: none;
}
.tetv-bulk-clear:hover {
  color: #855600;
  text-decoration: underline;
}

@media (max-width: 992px) {
  .tetv-view-switchbar {
    justify-content: center;
  }
  .tetv-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .tetv-toolbar-group,
  .tetv-toolbar-select {
    max-width: none;
    width: 100%;
  }
  .tetv-toolbar-options {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }
}

@media (max-width: 576px) {
  .tetv-grid-wrapper {
    border-left: 0;
    border-radius: 0;
    border-right: 0;
    margin-left: 0;
  }
  .tetv-view-toggle {
    width: 100%;
  }
  .tetv-view-toggle .btn {
    flex: 1 1 50%;
    justify-content: center;
  }
  .tetv-select-shell {
    min-width: 0;
    width: 100%;
  }
}

/* Header label + ? help icon. Renders inside both regular column headers and
   column-group headers via HeaderWithHelp / HeaderGroupWithHelp. Uses a full
   width flex container so trailing icons (e.g. the filter funnel) can be
   pushed to the right edge via margin-left: auto. */
.tetv-header-with-help {
  align-items: center;
  display: flex;
  gap: 6px;
  min-width: 0;
  width: 100%;
}
.tetv-header-with-help .tetv-header-label {
  white-space: normal;
  word-break: break-word;
  line-height: 1.2;
}
.tetv-header-help {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  line-height: 1;
}
/* The ? itself is a bare <button> so it is keyboard operable; strip the
   browser chrome so it still reads as an inline icon. */
.tetv-header-help-btn {
  align-items: center;
  background: none;
  border: none;
  color: #7a8aa0;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.85em;
  line-height: 1;
  padding: 0;
}
.tetv-header-help-btn:hover,
.tetv-header-help-btn:focus {
  color: var(--tetv-accent-dark);
}
/* The help popover is portalled to <body>, so it has to clear the fullscreen
   grid wrapper (z-index 2000) — Bootstrap's default 1060 renders under it. */
.popover.tetv-header-help-popover {
  max-width: 420px;
  z-index: 2100;
}
.tetv-header-help-popover .popover-header {
  font-size: 0.85rem;
  font-weight: 600;
}
.tetv-header-help-popover .popover-body {
  color: #333;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  max-height: 60vh;
  overflow-y: auto;
  text-align: left;
  white-space: normal;
}
/* Filter funnel icon rendered in HeaderWithHelp when the column opts in via
   headerComponentParams.showFilterIcon. Uses AgGrid's built-in
   .ag-icon-filter glyph to match the rest of the app. Pushed to the right
   edge of the header cell so it doesn't crowd the label / help icon. */
.tetv-header-filter {
  align-items: center;
  color: #7a8aa0;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.95em;
  line-height: 1;
  margin-left: auto;
  padding: 0 2px;
}
.tetv-header-filter:hover {
  color: var(--tetv-accent-dark);
}
.tetv-header-filter-active {
  color: var(--tetv-accent-dark);
}
.tetv-header-filter-active::after {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--tetv-accent-dark);
  margin-left: 2px;
}

/* Action bar rendered at the top of the react-select dropdown menu (Topics
   and Sources multi-selects). Keeps the bulk select/unselect actions inside
   the popup so the toolbar itself stays uncluttered. */
.tetv-multiselect-actions {
  display: flex;
  gap: 6px;
  padding: 6px 8px;
  border-bottom: 1px solid #e1e8ef;
  background: #f8fafc;
  position: sticky;
  top: 0;
  z-index: 1;
}
.tetv-multiselect-action {
  background: #fff;
  border: 1px solid #d7e1e8;
  border-radius: 999px;
  color: var(--tetv-accent-dark);
  cursor: pointer;
  flex: 1 1;
  font-size: var(--tetv-secondary-font-size);
  font-weight: 700;
  line-height: 1.1;
  padding: 5px 8px;
}
.tetv-multiselect-action:hover {
  background: #e8f3f6;
  border-color: #a9ccd6;
}

/* Wrapper that hosts the top scrollbar + AgGrid; gives the resize overlay an
   absolute-positioning anchor without taking over the whole page-level
   layout. */
.tetv-grid-stack {
  position: relative;
}

/* Floating "adjusting columns" toast shown while autoSize is in flight.
   Anchored to the top-center of the grid stack so it visually sits on top
   of the topic grid itself, not in the page corner. The stack uses
   position: relative which provides the containing block. */
.tetv-resize-overlay {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--tetv-line);
  border-radius: 999px;
  box-shadow: 0 10px 24px rgba(31, 41, 55, 0.18);
  color: var(--tetv-accent-dark);
  font-size: var(--tetv-secondary-font-size);
  font-weight: 600;
  pointer-events: none;
  white-space: nowrap;
}

/* Loading veil shown while TET data is (re)fetched. Covers the live grid
   instead of replacing it, so the AgGrid instance is never unmounted (which
   would crash on teardown with domLayout="autoHeight"). Anchored to the grid
   stack via position: relative on .tetv-grid-stack. */
.tetv-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 55;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  padding-top: 24px;
  background: rgba(255, 255, 255, 0.7);
  color: var(--tetv-accent-dark);
  font-size: var(--tetv-secondary-font-size);
  font-weight: 600;
}

/* Fullscreen toggle pill in the top-right of the grid wrapper. Sits above
   the sticky header (z-index 4) and the resize overlay (z-index 50). */
.tetv-fullscreen-toggle {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 60;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #d7e1e8;
  border-radius: 999px;
  color: var(--tetv-accent-dark);
  cursor: pointer;
  font-size: var(--tetv-secondary-font-size);
  font-weight: 700;
  line-height: 1.1;
  padding: 6px 12px;
  box-shadow: 0 2px 6px rgba(31, 41, 55, 0.08);
}
.tetv-fullscreen-toggle:hover {
  background: #e8f3f6;
  border-color: #a9ccd6;
}

/* Fullscreen mode: the wrapper covers the viewport and gains its own
   internal vertical scroller (the normal layout uses the page as the
   scroller, but in fullscreen there is no page below us). */
.tetv-grid-wrapper.tetv-fullscreen {
  position: fixed;
  inset: 0;
  margin: 0;
  border-radius: 0;
  border: 0;
  box-shadow: none;
  overflow: auto;
  z-index: 2000;
  background: #fff;
}
.tetv-grid-wrapper.tetv-fullscreen .tetv-fullscreen-toggle {
  position: fixed;
}

/* Optional curation-status section in the validation confirmation modal. */
.tetv-curation-toggle {
  background: #fbfcfd;
  border: 1px solid #e1e8ef;
  border-radius: 6px;
  padding: 8px 12px;
}
.tetv-curation-section {
  background: #f6f9fb;
  border: 1px solid #e1e8ef;
  border-radius: 6px;
  padding: 12px;
}

/* "New tag fields" preview block inside the validation confirmation modal. */
.tetv-validation-fields {
  background: #f6f9fb;
  border: 1px solid #e1e8ef;
  border-radius: 6px;
  padding: 10px 12px;
}
.tetv-validation-fields-title {
  color: #475467;
  font-size: 0.85em;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
  text-transform: uppercase;
}
.tetv-validation-fields-list {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 4px 12px;
  margin: 0;
}
.tetv-validation-fields-list dt {
  color: #667085;
  font-weight: 600;
  font-size: 0.9em;
}
.tetv-validation-fields-list dd {
  color: #1f2937;
  font-size: 0.9em;
  margin: 0;
  word-break: break-word;
}

/* Inline error indicator next to the validation strip when a submit fails. */
.tetv-strip-error {
  align-items: center;
  background: #fdecea;
  border: 1px solid #f5b7b1;
  border-radius: 50%;
  color: #b03a2e;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  height: 20px;
  justify-content: center;
  margin-left: 4px;
  width: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/components/refs_tet_validation/TetValidationGrid.css"],"names":[],"mappings":"AAAA;EACE;;gCAE8B;EAC9B,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,yCAAyC;EACzC,qCAAqC;EACrC,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;EAC9B,+CAA+C;EAC/C,2CAA2C;EAC3C,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,8CAA8C;EAC9C,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;EAClD,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;;;;;0EAK0E;AAC1E;;;EAGE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;AACA;;;;oFAIoF;AACpF;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;6CAG6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;;sDAEsD;AACtD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;;;4DAG4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB;;iFAE+E;EAC/E,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;;mDAEmD;AACnD;EACE,+BAA+B;AACjC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;AACA;;;yEAGyE;AACzE;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;;gCAEgC;AAChC;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;;yBAEyB;AACzB;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;+CAE+C;AAC/C;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;4EAC4E;AAC5E;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB;oDACkD;EAClD,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB;;oBAEkB;AACpB;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;AAChD;AACA,eAAe,mBAAmB,EAAE;AACpC,eAAe,mBAAmB,EAAE;AACpC;4CAC4C;AAC5C,oBAAoB,mBAAmB,EAAE;AACzC,wBAAwB,mBAAmB,EAAE;AAC7C;EACE,SAAS;EACT,eAAe;EACf,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;AACA,cAAc,mBAAmB,EAAE;AACnC,cAAc,mBAAmB,EAAE;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,kDAAkD;EAClD,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,uBAAuB,8BAA8B,EAAE;AACvD;EACE,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gFAAgF;AAClF;AACA,2BAA2B,YAAY,EAAE,eAAe,EAAE;AAC1D,kBAAkB,cAAc,EAAE;AAClC,kBAAkB,cAAc,EAAE;AAClC,uCAAuC,2BAA2B,EAAE;AACpE;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;;;EAGE,0CAA0C;EAC1C,WAAW;EACX,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,kBAAkB,8BAA8B,EAAE,gBAAgB,EAAE;;AAEpE;;qDAEqD;AACrD;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;;AAEA,2EAA2E;AAC3E;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,SAAS;AACX;;AAEA;;gEAEgE;AAChE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,sCAAsC;EACtC,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;;IAEE,eAAe;IACf,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;;;oDAGoD;AACpD;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;AACA;wDACwD;AACxD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,8BAA8B;AAChC;AACA;6EAC6E;AAC7E;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;uEAGuE;AACvE;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;uDAEuD;AACvD;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,SAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;YAEY;AACZ;EACE,kBAAkB;AACpB;;AAEA;;;4DAG4D;AAC5D;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,kCAAkC;EAClC,oBAAoB;EACpB,8CAA8C;EAC9C,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;sDAGsD;AACtD;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;uEACuE;AACvE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;4DAE4D;AAC5D;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA,6EAA6E;AAC7E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".tetv-grid-wrapper {\n  --tetv-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',\n    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif;\n  --tetv-font-size: 1rem;\n  --tetv-secondary-font-size: 0.875rem;\n  --tetv-small-font-size: 0.8rem;\n  --tetv-accent: #3f8fa3;\n  --tetv-accent-dark: #256274;\n  --tetv-ink: #1f2937;\n  --tetv-muted: #667085;\n  --tetv-line: #d9e1ea;\n  --tetv-soft: #f6f9fb;\n  --ag-font-family: var(--tetv-font-family);\n  --ag-font-size: var(--tetv-font-size);\n  --ag-foreground-color: var(--tetv-ink);\n  --ag-border-color: var(--tetv-line);\n  --ag-row-border-color: #94a3b8;\n  --ag-header-column-resize-handle-color: #9fb3c6;\n  --ag-selected-row-background-color: #e8f3f6;\n  font-family: var(--tetv-font-family);\n  font-size: var(--tetv-font-size);\n  color: var(--tetv-ink);\n  background: #fff;\n  border: 1px solid var(--tetv-line);\n  border-radius: 8px;\n  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.08);\n  box-sizing: border-box;\n  margin-top: 8px;\n  margin-left: 12px;\n  padding: 0 0 12px;\n}\n\n.tetv-view-switchbar {\n  display: flex;\n  justify-content: center;\n  padding: 6px 0 10px;\n}\n.tetv-view-toggle {\n  background: #f2f6f8;\n  border: 1px solid #d7e1e8;\n  border-radius: 8px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\n  padding: 3px;\n}\n.tetv-view-toggle .btn {\n  align-items: center;\n  border: 0;\n  border-radius: 6px !important;\n  display: inline-flex;\n  gap: 6px;\n  font-weight: 600;\n  line-height: 1.2;\n  padding: 0.35rem 0.65rem;\n}\n.tetv-view-toggle .btn-outline-secondary {\n  color: #506172;\n}\n.tetv-view-toggle .btn-outline-secondary:hover,\n.tetv-view-toggle .btn-outline-secondary:not(:disabled):not(.disabled).active {\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(31, 41, 55, 0.12);\n  color: #256274;\n}\n\n/* Sticky AgGrid header + a separate sticky horizontal scrollbar at the top.\n   With domLayout=\"autoHeight\" the grid has no internal vertical scrolling — the\n   page is the only scroller. We pin .ag-header so column headers stay visible\n   only once the user has actually scrolled past them; position:sticky kicks in\n   exactly at top:0. The override on .ag-root-wrapper / .ag-root removes the\n   overflow:hidden ancestors that would otherwise clip the sticky child. */\n.tetv-grid-wrapper .ag-root-wrapper,\n.tetv-grid-wrapper .ag-root,\n.tetv-grid-wrapper .ag-body-viewport {\n  overflow: visible;\n}\n.tetv-grid-wrapper .ag-root-wrapper {\n  border-left: 0;\n  border-radius: 0 0 8px 8px;\n  border-right: 0;\n}\n/* Top scrollbar lives between the AgGrid header and the body. It is rendered via\n   a React portal into a display:contents container placed after .ag-header inside\n   .ag-root (see TetValidationGrid.jsx), so its sticky context is .ag-root while\n   React keeps ownership of the node. The sticky `top` is set inline based on the\n   measured header height so it pins right below the header when the page scrolls. */\n.tetv-top-scroll {\n  position: sticky;\n  z-index: 3;\n  overflow-x: auto;\n  overflow-y: hidden;\n  background: #f8fafc;\n  border-top: 1px solid #d7e1e8;\n  border-bottom: 1px solid #dfe7ef;\n  height: 16px;\n}\n.tetv-top-scroll-inner {\n  height: 1px;\n}\n.tetv-grid-wrapper .ag-header {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n}\n.tetv-banner-unresolved {\n  background: #fff3cd;\n  padding: 6px 10px;\n  margin: 10px 12px 0;\n  border: 1px solid #ffe69c;\n  border-radius: 7px;\n  font-size: var(--tetv-font-size);\n}\n\n.tetv-toolbar {\n  background: #fbfcfd;\n  border-bottom: 1px solid var(--tetv-line);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  padding: 10px 12px;\n  align-items: center;\n}\n.tetv-toolbar-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.tetv-toolbar-options {\n  background: #fff;\n  border: 1px solid #e1e8ef;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(31, 41, 55, 0.04);\n  gap: 12px;\n  padding: 6px 10px;\n}\n.tetv-toolbar-options .form-check {\n  align-items: center;\n  display: inline-flex;\n  margin-bottom: 0;\n  margin-right: 0;\n}\n.tetv-toolbar-options .form-check-input {\n  margin-top: 0;\n}\n.tetv-toolbar-options .form-check-label {\n  color: #344054;\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 600;\n  padding-left: 4px;\n}\n.tetv-toolbar-select {\n  flex: 1 1 280px;\n  min-width: 240px;\n  max-width: 480px;\n}\n.tetv-toolbar-label {\n  font-size: var(--tetv-secondary-font-size);\n  color: #344054;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.tetv-quick-link {\n  background: #fff;\n  border: 1px solid #d7e1e8;\n  color: var(--tetv-accent-dark);\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 700;\n  line-height: 1.1;\n  padding: 5px 8px;\n  cursor: pointer;\n  border-radius: 999px;\n}\n.tetv-quick-link:hover {\n  background: #e8f3f6;\n  border-color: #a9ccd6;\n}\n.tetv-select-shell {\n  flex: 1 1 240px;\n  min-width: 240px;\n}\n\n/* Each topic is rendered as a column group with two children: Validation\n   (narrow, just buttons) and Sources (wide, source mini-rows).\n   We draw a thick left border on the leftmost cell of each topic group to\n   visually separate adjacent topic groups. */\n.tetv-validation-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 2px;\n  padding: 4px 2px;\n  height: 100%;\n}\n.tetv-validation-by {\n  font-size: var(--tetv-small-font-size);\n  color: #4a5260;\n  line-height: 1.25;\n  text-align: center;\n  word-break: break-word;\n}\n.tetv-validation-by-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  align-items: stretch;\n  width: 100%;\n}\n.tetv-validation-by-mark {\n  display: inline-block;\n  font-weight: 700;\n  min-width: 1.1em;\n  padding: 0 4px;\n  border-radius: 8px;\n  text-align: center;\n  color: #fff;\n}\n.tetv-validation-by-pos { background: #1e7d3a; }\n.tetv-validation-by-neg { background: #b03a2e; }\n.tetv-source-icon {\n  display: inline-block;\n  min-width: 1.4em;\n  padding: 0 6px;\n  height: 1.4em;\n  border-radius: 999px;\n  background: var(--tetv-accent);\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.8em;\n  line-height: 1.4em;\n  text-align: center;\n  margin: 0 2px;\n  vertical-align: middle;\n}\n/* Species badge: same shape/size as source icons but a distinct olive hue so\n   curators can tell at a glance which TET tags were submitted for a given\n   species. Hover tooltip carries the full binomial. */\n.tetv-species-icon {\n  display: inline-block;\n  min-width: 1.4em;\n  padding: 0 6px;\n  height: 1.4em;\n  border-radius: 999px;\n  background: #6b7c3a;\n  color: #fff;\n  font-weight: 700;\n  font-style: italic;\n  font-size: 0.8em;\n  line-height: 1.4em;\n  text-align: center;\n  margin: 0 2px;\n  vertical-align: middle;\n}\n.tetv-sources-cell,\n.tetv-tag-cell,\n.tetv-attr-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 4px 6px;\n  min-width: 0;\n}\n.tetv-tag-cell {\n  align-items: center;\n}\n/* Evidence-assertion panels: one panel per source_evidence_assertion bucket.\n   Sources column shows the assertion name as a panel title; the other\n   per-source columns render a same-height spacer so mini-rows still align\n   horizontally across columns inside a single AgGrid row. */\n.tetv-evidence-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n}\n.tetv-evidence-panel-sep {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid #d9e1ea;\n}\n.tetv-evidence-title {\n  font-size: var(--tetv-small-font-size);\n  font-weight: 700;\n  color: var(--tetv-accent-dark);\n  text-transform: lowercase;\n  line-height: 1.3;\n  padding: 0 0 2px;\n  text-align: left;\n  /* Resolved ontology names can exceed the fixed Sources column width; clip to a\n     single line (keeping the one-line title-spacer height match that preserves\n     cross-column mini-row alignment) and expose the full text via the tooltip. */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.tetv-evidence-title-spacer {\n  font-size: var(--tetv-small-font-size);\n  font-weight: 700;\n  line-height: 1.3;\n  padding: 0 0 2px;\n  visibility: hidden;\n  text-align: left;\n}\n.tetv-evidence-empty {\n  color: var(--tetv-muted);\n  font-size: var(--tetv-small-font-size);\n}\n.tetv-attr-value {\n  font-size: inherit;\n  color: #2a2f36;\n  font-variant-numeric: tabular-nums;\n}\n.tetv-note-count {\n  font-size: var(--tetv-small-font-size);\n  margin-left: 2px;\n}\n/* Inner separators between sub-columns within a topic group, matching the\n   sub-header borders. The leftmost cell of each topic group keeps a thicker\n   left border to separate adjacent topic groups. */\n.tetv-grid-wrapper .ag-cell {\n  border-right: 1px solid #e5ebf1;\n}\n.tetv-grid-wrapper .ag-header-cell.tetv-topic-subheader,\n.tetv-grid-wrapper .ag-header-group-cell.tetv-topic-group-header {\n  border-right: 1px solid #d0dce7;\n}\n.tetv-topic-group-leftmost {\n  border-left: 3px solid #a9ccd6 !important;\n}\n.tetv-grid-wrapper .ag-header,\n.tetv-grid-wrapper .ag-header-row {\n  background: #eef4f7;\n}\n.tetv-grid-wrapper .ag-header-cell,\n.tetv-grid-wrapper .ag-header-group-cell {\n  background: #eef4f7;\n  color: var(--tetv-ink);\n  font-weight: 700;\n}\n.tetv-grid-wrapper .ag-header-cell-label,\n.tetv-grid-wrapper .ag-header-group-cell-label {\n  align-items: center;\n}\n.ag-header-group-cell.tetv-topic-group-header {\n  border-left: 3px solid #a9ccd6;\n  background: linear-gradient(180deg, #e7f1f4, #dfeaf0);\n  font-weight: 700;\n  color: var(--tetv-accent-dark);\n}\n.ag-header-cell.tetv-topic-subheader {\n  background: #f8fafc;\n  font-size: var(--tetv-secondary-font-size);\n  color: #475467;\n  font-weight: 600;\n}\n/* Nested group inside a topic group: the \"Data assessment by other sources\"\n   band that spans the source label, its Y/N/{N}E tag and the optional\n   confidence / note columns. Toned between the topic-name band above it and\n   the leaf sub-headers below so the three levels stay distinguishable. */\n.ag-header-group-cell.tetv-topic-subgroup-header {\n  background: #eef3f7;\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 700;\n  color: #3d5566;\n  border-right: 1px solid #d0dce7;\n  border-bottom: 1px solid #dbe4ec;\n}\n/* The biocurator column has no nested group above it, so AgGrid renders an\n   empty group cell in that row. Keep it blank rather than showing a stray\n   band of the sub-group tone. */\n.tetv-grid-wrapper .ag-header-group-cell-no-group {\n  background: #f8fafc;\n  border-right: 1px solid #d0dce7;\n}\n/* Alternating row tones for readability. Each paper is separated by a\n   prominent slate-grey divider so curators clearly see where one paper ends\n   and the next begins. */\n.tetv-grid-wrapper .ag-row {\n  background: #ffffff;\n  border-bottom: 2px solid #94a3b8;\n}\n.tetv-grid-wrapper .ag-row-odd {\n  background: #f8fafc;\n}\n.tetv-grid-wrapper .ag-row:hover {\n  background: #edf8f7;\n}\n/* Reference rows that already carry a professional-biocurator topic-level\n   TET on at least one topic — soft amber background so curators spot them\n   immediately. Overrides the zebra striping. */\n.tetv-grid-wrapper .ag-row.tetv-row-validated,\n.tetv-grid-wrapper .ag-row.tetv-row-validated.ag-row-odd {\n  background: #fff8ed;\n}\n.tetv-grid-wrapper .ag-row.tetv-row-validated:hover {\n  background: #ffefd1;\n}\n\n/* Status text shown in the Validation cell when a professional-biocurator\n   topic-level tag exists for that (ref, topic). Replaces the ✓/✗ buttons. */\n.tetv-validation-status {\n  font-size: 1rem;\n  font-weight: 700;\n  padding: 7px 14px;\n  /* Y and N are single characters — keep both pills the same size so a column\n     of assessments reads as one consistent shape. */\n  min-width: 2.75rem;\n  border-radius: 999px;\n  text-align: center;\n  white-space: normal;\n  line-height: 1.25;\n  border: 1px solid transparent;\n  box-shadow: 0 1px 2px rgba(31, 41, 55, 0.08);\n}\n.tetv-validated-pos {\n  background: #dff4e7;\n  color: #17613a;\n  border-color: #b9e4c8;\n}\n.tetv-validated-neg {\n  background: #fde3e8;\n  color: #8f2435;\n  border-color: #f7bdc8;\n}\n.tetv-validated-conflict {\n  background: #fff0c9;\n  color: #855600;\n  border-color: #f3d27e;\n}\n.tetv-source-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.tetv-source-group-sep {\n  border-top: 1px dotted #ddd;\n  padding-top: 2px;\n}\n.tetv-mini-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--tetv-font-size);\n  line-height: 1.3;\n  flex-wrap: nowrap;\n  /* Single-line mini-rows so the columns can be auto-sized to fit content\n     without vertical stacking. The grid horizontal-scrolls when wider than\n     the viewport. */\n}\n.tetv-tag-row {\n  justify-content: center;\n  width: 100%;\n}\n.tetv-source-label {\n  color: #475467;\n  white-space: nowrap;\n  font-weight: 500;\n}\n.tetv-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 26px;\n  padding: 0 7px;\n  border-radius: 999px;\n  color: #fff;\n  font-size: var(--tetv-small-font-size);\n  font-weight: 800;\n  text-align: center;\n  line-height: 20px;\n  height: 20px;\n  white-space: nowrap;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.13);\n}\n.tetv-pill-y { background: #268d52; }\n.tetv-pill-n { background: #c63f4f; }\n/* Entity count badge — distinct violet so curators can spot it apart from\n   the Y/N pills used for topic-only tags. */\n.tetv-pill-entity { background: #6679c8; }\n.tetv-pill-entity-neg { background: #495aa2; }\n.tetv-pill-clickable {\n  border: 0;\n  cursor: pointer;\n  font: inherit;\n}\n.tetv-pill-clickable:hover {\n  filter: brightness(1.08);\n  transform: translateY(-1px);\n}\n.tetv-dot-y, .tetv-dot-n {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n.tetv-dot-y { background: #268d52; }\n.tetv-dot-n { background: #c63f4f; }\n.tetv-inline-note {\n  color: #333;\n  font-style: italic;\n  /* Full note text — wraps freely, no truncation. */\n  white-space: pre-wrap;\n  word-break: break-word;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.tetv-inline-note-line {\n  display: block;\n}\n.tetv-inline-note-entity {\n  font-weight: 600;\n  font-style: normal;\n  color: #2a2f36;\n}\n.tetv-note-btn {\n  background: none;\n  border: 0;\n  color: #667085;\n  cursor: pointer;\n  padding: 0 2px;\n}\n.tetv-note-btn:hover { color: var(--tetv-accent-dark); }\n.tetv-badge {\n  font-size: var(--tetv-small-font-size);\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: #edf1fb;\n  color: #3c4f8f;\n  font-weight: 700;\n}\n.tetv-badge-score {\n  background: #e8f4ed;\n  color: #276749;\n}\n\n/* Validation strip: horizontal pair of icon-only buttons. */\n.tetv-strip {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  padding: 0;\n  border: 0;\n  flex: 0 0 auto;\n}\n.tetv-strip-btn {\n  background: #fff;\n  border: 1px solid #d7e1e8;\n  border-radius: 999px;\n  padding: 4px 10px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  width: auto;\n  height: 36px;\n  font-size: 24px;\n  line-height: 1;\n  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;\n}\n.tetv-strip-btn:disabled { opacity: 0.4; cursor: default; }\n.tetv-strip-pos { color: #268d52; }\n.tetv-strip-neg { color: #c63f4f; }\n.tetv-strip-btn:hover:not(:disabled) { transform: translateY(-1px); }\n.tetv-strip-pos:hover:not(:disabled) {\n  background: #e7f5ec;\n  border-color: #9ad0ae;\n}\n.tetv-strip-neg:hover:not(:disabled) {\n  background: #fdecef;\n  border-color: #e8a5af;\n}\n.tetv-strip-active {\n  background: #f2f6f8;\n  border-color: #8ba6b6;\n}\n\n.tetv-title-cell,\n.tetv-ids-cell {\n  display: flex;\n  flex-direction: column;\n  padding: 4px;\n  line-height: 1.3;\n}\n.tetv-title-cell {\n  white-space: normal;\n}\n.tetv-ids-cell {\n  white-space: nowrap;\n}\n.tetv-ref-title {\n  color: var(--tetv-ink);\n  font-weight: 600;\n  word-break: break-word;\n}\n.tetv-ref-journal {\n  font-size: var(--tetv-secondary-font-size);\n  color: #667085;\n  font-style: italic;\n}\n.tetv-ref-authors {\n  font-size: var(--tetv-secondary-font-size);\n  color: #667085;\n}\n.tetv-ref-curie,\n.tetv-ref-pmid,\n.tetv-ref-xref {\n  font-size: var(--tetv-secondary-font-size);\n  color: #555;\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: normal;\n  word-break: normal;\n  white-space: nowrap;\n}\n.tetv-ref-curie { color: var(--tetv-accent-dark); font-weight: 700; }\n\n/* Per-reference action strip rendered at the bottom of IdsCell. Mirrors\n   the list-view's TET-editor + main-PDF buttons but in a compact pill\n   layout so it doesn't dominate the pinned column. */\n.tetv-ref-actions {\n  display: flex;\n  gap: 6px;\n  margin-top: 4px;\n}\n.tetv-ref-action {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #d7e1e8;\n  border-radius: 999px;\n  color: var(--tetv-accent-dark);\n  cursor: pointer;\n  display: inline-flex;\n  font-size: var(--tetv-small-font-size);\n  font-weight: 700;\n  gap: 4px;\n  line-height: 1.1;\n  padding: 3px 8px;\n  text-decoration: none;\n}\n.tetv-ref-action:hover {\n  background: #e8f3f6;\n  border-color: #a9ccd6;\n  color: var(--tetv-accent-dark);\n  text-decoration: none;\n}\n.tetv-ref-action-pdf {\n  color: #8c2c2c;\n  border-color: #e6c2c2;\n}\n.tetv-ref-action-pdf:hover {\n  background: #fbecec;\n  border-color: #d99a9a;\n  color: #6e2222;\n}\n.tetv-ref-action-label {\n  font-size: var(--tetv-small-font-size);\n}\n\n/* Leading pinned checkbox column for bulk selection. Compact + centered. */\n.tetv-grid-wrapper .ag-cell.tetv-select-cell,\n.tetv-grid-wrapper .ag-header-cell.tetv-select-header {\n  padding-left: 8px;\n  padding-right: 4px;\n}\n.tetv-grid-wrapper .ag-cell.tetv-select-cell .ag-selection-checkbox,\n.tetv-grid-wrapper .ag-header-cell.tetv-select-header .ag-header-select-all {\n  margin: 0;\n}\n\n/* Bulk-action bar — visible only when at least one row is checkbox-selected.\n   Sits between the regular toolbar and the grid, with a coloured stripe so\n   the curator notices they're operating on a multi-row batch. */\n.tetv-bulk-bar {\n  align-items: center;\n  background: #fff8ed;\n  border-bottom: 1px solid var(--tetv-line);\n  border-top: 1px solid var(--tetv-line);\n  border-left: 4px solid #f3b765;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  padding: 10px 12px;\n}\n.tetv-bulk-count {\n  color: #6b4a16;\n  font-weight: 600;\n}\n.tetv-bulk-count strong {\n  color: #855600;\n  font-size: 1.05em;\n}\n.tetv-bulk-msg {\n  color: #475467;\n}\n.tetv-bulk-topic {\n  align-items: center;\n  display: inline-flex;\n}\n.tetv-bulk-label {\n  color: #344054;\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 700;\n}\n.tetv-bulk-actions {\n  align-items: center;\n  display: inline-flex;\n  gap: 8px;\n  margin-left: auto;\n}\n.tetv-bulk-clear {\n  color: #6b4a16;\n  text-decoration: none;\n}\n.tetv-bulk-clear:hover {\n  color: #855600;\n  text-decoration: underline;\n}\n\n@media (max-width: 992px) {\n  .tetv-view-switchbar {\n    justify-content: center;\n  }\n  .tetv-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .tetv-toolbar-group,\n  .tetv-toolbar-select {\n    max-width: none;\n    width: 100%;\n  }\n  .tetv-toolbar-options {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 6px;\n  }\n}\n\n@media (max-width: 576px) {\n  .tetv-grid-wrapper {\n    border-left: 0;\n    border-radius: 0;\n    border-right: 0;\n    margin-left: 0;\n  }\n  .tetv-view-toggle {\n    width: 100%;\n  }\n  .tetv-view-toggle .btn {\n    flex: 1 1 50%;\n    justify-content: center;\n  }\n  .tetv-select-shell {\n    min-width: 0;\n    width: 100%;\n  }\n}\n\n/* Header label + ? help icon. Renders inside both regular column headers and\n   column-group headers via HeaderWithHelp / HeaderGroupWithHelp. Uses a full\n   width flex container so trailing icons (e.g. the filter funnel) can be\n   pushed to the right edge via margin-left: auto. */\n.tetv-header-with-help {\n  align-items: center;\n  display: flex;\n  gap: 6px;\n  min-width: 0;\n  width: 100%;\n}\n.tetv-header-with-help .tetv-header-label {\n  white-space: normal;\n  word-break: break-word;\n  line-height: 1.2;\n}\n.tetv-header-help {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  line-height: 1;\n}\n/* The ? itself is a bare <button> so it is keyboard operable; strip the\n   browser chrome so it still reads as an inline icon. */\n.tetv-header-help-btn {\n  align-items: center;\n  background: none;\n  border: none;\n  color: #7a8aa0;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 0.85em;\n  line-height: 1;\n  padding: 0;\n}\n.tetv-header-help-btn:hover,\n.tetv-header-help-btn:focus {\n  color: var(--tetv-accent-dark);\n}\n/* The help popover is portalled to <body>, so it has to clear the fullscreen\n   grid wrapper (z-index 2000) — Bootstrap's default 1060 renders under it. */\n.popover.tetv-header-help-popover {\n  max-width: 420px;\n  z-index: 2100;\n}\n.tetv-header-help-popover .popover-header {\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n.tetv-header-help-popover .popover-body {\n  color: #333;\n  font-size: 0.8rem;\n  font-weight: 400;\n  line-height: 1.5;\n  max-height: 60vh;\n  overflow-y: auto;\n  text-align: left;\n  white-space: normal;\n}\n/* Filter funnel icon rendered in HeaderWithHelp when the column opts in via\n   headerComponentParams.showFilterIcon. Uses AgGrid's built-in\n   .ag-icon-filter glyph to match the rest of the app. Pushed to the right\n   edge of the header cell so it doesn't crowd the label / help icon. */\n.tetv-header-filter {\n  align-items: center;\n  color: #7a8aa0;\n  cursor: pointer;\n  display: inline-flex;\n  flex: 0 0 auto;\n  font-size: 0.95em;\n  line-height: 1;\n  margin-left: auto;\n  padding: 0 2px;\n}\n.tetv-header-filter:hover {\n  color: var(--tetv-accent-dark);\n}\n.tetv-header-filter-active {\n  color: var(--tetv-accent-dark);\n}\n.tetv-header-filter-active::after {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--tetv-accent-dark);\n  margin-left: 2px;\n}\n\n/* Action bar rendered at the top of the react-select dropdown menu (Topics\n   and Sources multi-selects). Keeps the bulk select/unselect actions inside\n   the popup so the toolbar itself stays uncluttered. */\n.tetv-multiselect-actions {\n  display: flex;\n  gap: 6px;\n  padding: 6px 8px;\n  border-bottom: 1px solid #e1e8ef;\n  background: #f8fafc;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n.tetv-multiselect-action {\n  background: #fff;\n  border: 1px solid #d7e1e8;\n  border-radius: 999px;\n  color: var(--tetv-accent-dark);\n  cursor: pointer;\n  flex: 1 1 0;\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 700;\n  line-height: 1.1;\n  padding: 5px 8px;\n}\n.tetv-multiselect-action:hover {\n  background: #e8f3f6;\n  border-color: #a9ccd6;\n}\n\n/* Wrapper that hosts the top scrollbar + AgGrid; gives the resize overlay an\n   absolute-positioning anchor without taking over the whole page-level\n   layout. */\n.tetv-grid-stack {\n  position: relative;\n}\n\n/* Floating \"adjusting columns\" toast shown while autoSize is in flight.\n   Anchored to the top-center of the grid stack so it visually sits on top\n   of the topic grid itself, not in the page corner. The stack uses\n   position: relative which provides the containing block. */\n.tetv-resize-overlay {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 50;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid var(--tetv-line);\n  border-radius: 999px;\n  box-shadow: 0 10px 24px rgba(31, 41, 55, 0.18);\n  color: var(--tetv-accent-dark);\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 600;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n/* Loading veil shown while TET data is (re)fetched. Covers the live grid\n   instead of replacing it, so the AgGrid instance is never unmounted (which\n   would crash on teardown with domLayout=\"autoHeight\"). Anchored to the grid\n   stack via position: relative on .tetv-grid-stack. */\n.tetv-loading-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 55;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 8px;\n  padding-top: 24px;\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--tetv-accent-dark);\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 600;\n}\n\n/* Fullscreen toggle pill in the top-right of the grid wrapper. Sits above\n   the sticky header (z-index 4) and the resize overlay (z-index 50). */\n.tetv-fullscreen-toggle {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  z-index: 60;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #fff;\n  border: 1px solid #d7e1e8;\n  border-radius: 999px;\n  color: var(--tetv-accent-dark);\n  cursor: pointer;\n  font-size: var(--tetv-secondary-font-size);\n  font-weight: 700;\n  line-height: 1.1;\n  padding: 6px 12px;\n  box-shadow: 0 2px 6px rgba(31, 41, 55, 0.08);\n}\n.tetv-fullscreen-toggle:hover {\n  background: #e8f3f6;\n  border-color: #a9ccd6;\n}\n\n/* Fullscreen mode: the wrapper covers the viewport and gains its own\n   internal vertical scroller (the normal layout uses the page as the\n   scroller, but in fullscreen there is no page below us). */\n.tetv-grid-wrapper.tetv-fullscreen {\n  position: fixed;\n  inset: 0;\n  margin: 0;\n  border-radius: 0;\n  border: 0;\n  box-shadow: none;\n  overflow: auto;\n  z-index: 2000;\n  background: #fff;\n}\n.tetv-grid-wrapper.tetv-fullscreen .tetv-fullscreen-toggle {\n  position: fixed;\n}\n\n/* Optional curation-status section in the validation confirmation modal. */\n.tetv-curation-toggle {\n  background: #fbfcfd;\n  border: 1px solid #e1e8ef;\n  border-radius: 6px;\n  padding: 8px 12px;\n}\n.tetv-curation-section {\n  background: #f6f9fb;\n  border: 1px solid #e1e8ef;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n/* \"New tag fields\" preview block inside the validation confirmation modal. */\n.tetv-validation-fields {\n  background: #f6f9fb;\n  border: 1px solid #e1e8ef;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n.tetv-validation-fields-title {\n  color: #475467;\n  font-size: 0.85em;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n}\n.tetv-validation-fields-list {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  gap: 4px 12px;\n  margin: 0;\n}\n.tetv-validation-fields-list dt {\n  color: #667085;\n  font-weight: 600;\n  font-size: 0.9em;\n}\n.tetv-validation-fields-list dd {\n  color: #1f2937;\n  font-size: 0.9em;\n  margin: 0;\n  word-break: break-word;\n}\n\n/* Inline error indicator next to the validation strip when a submit fails. */\n.tetv-strip-error {\n  align-items: center;\n  background: #fdecea;\n  border: 1px solid #f5b7b1;\n  border-radius: 50%;\n  color: #b03a2e;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 12px;\n  height: 20px;\n  justify-content: center;\n  margin-left: 4px;\n  width: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
